export class RequestError {
    _responseJSON: any;
    _responseText: string;
    _error: string;

    constructor(responseText: string, error: string) {
        this._responseText = responseText;
        this._error = error;

        try {
            this._responseJSON = JSON.parse(responseText);
        }
        catch (e) {
            this._responseJSON = null;
        }
    }

    get responseText(): any {
        return this._responseText;
    }

    get responseJSON(): any {
        return this._responseJSON;
    }

    get error(): string {
        return this._error;
    }
}
